type Props = {
  tone?: 'light' | 'dark';
};

export function HeroSwoosh({ tone = 'light' }: Props) {
  const stroke = tone === 'light' ? 'rgba(255,255,255,0.20)' : 'rgba(255,255,255,0.18)';
  return (
    <svg className="hero-swoosh" viewBox="0 0 1600 720" preserveAspectRatio="none" aria-hidden>
      <defs>
        <linearGradient id="swooshFade" x1="0" x2="1" y1="0" y2="0">
          <stop offset="0" stopColor="#fff" stopOpacity="0.05" />
          <stop offset=".5" stopColor="#fff" stopOpacity="0.22" />
          <stop offset="1" stopColor="#fff" stopOpacity="0.05" />
        </linearGradient>
      </defs>
      <path
        d="M -100 520 C 380 60, 1020 60, 1700 520 L 1700 720 L -100 720 Z"
        fill="url(#swooshFade)"
        opacity=".18"
      />
      <path
        d="M -100 560 C 380 120, 1020 120, 1700 560"
        fill="none"
        stroke={stroke}
        strokeWidth="1.2"
      />
      <path
        d="M -100 600 C 380 180, 1020 180, 1700 600"
        fill="none"
        stroke={stroke}
        strokeWidth="1.2"
        opacity=".7"
      />
      <path
        d="M -100 640 C 380 240, 1020 240, 1700 640"
        fill="none"
        stroke={stroke}
        strokeWidth="1.2"
        opacity=".45"
      />
    </svg>
  );
}
